<div>
    <app-mentornavbar></app-mentornavbar>
</div>
<div class="body">
    <div class="head">
        <h1>Mentor Profile</h1>
    </div>
    <div class="cont">
        <div class="profile">
            <div class="firstrow">
                <div class="image">
                    <img src={{mentordata.profile_img}} alt="">
                </div>
                <div class="basic">
                    <h1>{{mentordata.mentor_id}}</h1>
                    <h1>{{mentordata.name}}</h1>
                    <!-- <h1>Designation</h1> -->
                </div>
            </div>
            <div class="secondrow">
                <p>{{mentordata.expertise}}</p>
            </div>
        </div>
    <div class="slots">
        <h2>Select a Slot</h2>
        <div class="slot" *ngFor="let slot of slots">
            <button class="btn btn-lg inverse" (click)="selectslot(slot.id)" [disabled]="slot.isbooked">{{formatDateAndTime(slot.date, slot.time)}}</button>
        </div>
        <div class="book">
            <button class="btn btn-lg inverse2" (click)="bookslot()">Book Slot</button>
        </div>
    </div>
    </div>
    <div class="head">
        <a routerLink="/empmentor"><button class="btn btn-lg">View More Mentors</button></a>
    </div>
</div>